import { BASE_API_URL } from "config/config";
import httpExpection from "utils/httpException";

export const getAllMarkets = async () => {
  try {
    const response = await fetch(`${BASE_API_URL}markets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("session")}`,
      },
    });

    if (!response.ok) {
      throw response;
    }

    const data = await response.json();
    return data;
  } catch (e) {
    httpExpection(e);
    throw await e.json();
  }
};

export const deleteMarket = async (id) => {
  try {
    const response = await fetch(`${BASE_API_URL}markets/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("session")}`,
      },
    });

    if (!response.ok) {
      throw response;
    }

    const data = await response.json();
    return data;
  } catch (e) {
    httpExpection(e);
    throw await e.json();
  }
};

export const createMarket = async (name, eventId) => {
  try {
    const response = await fetch(`${BASE_API_URL}markets`, {
      method: "POST",
      body: JSON.stringify({
        name,
        eventId: Number(eventId),
      }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("session")}`,
      },
    });

    if (!response.ok) {
      throw response;
    }

    const data = await response.json();
    return data;
  } catch (e) {
    httpExpection(e);
    throw await e.json();
  }
};
